<template>
  <SectionContainerPage>
    <SectionManufacturerList
      xs12
      :manufacturerList="manufacturerList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Manufacturer',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewManufacturerClicked',
        },
      ]"
      @onAddNewManufacturerClicked="showDialogFormManufacturerAdd = true"
      @onEditManufacturerClicked="
        (val) => [
          (manufacturerToEdit = val.manufacturerToEdit),
          (showDialogFormManufacturerEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormManufacturerAdd
      :showDialog="showDialogFormManufacturerAdd"
      @onCancelClicked="showDialogFormManufacturerAdd = false"
      @onSubmitClicked="(val) => [onDialogFormManufacturerAddSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormManufacturerEdit
      :showDialog="showDialogFormManufacturerEdit"
      @onCancelClicked="showDialogFormManufacturerEdit = false"
      :manufacturerToEdit="manufacturerToEdit"
      @onSubmitClicked="(val) => [onDialogFormManufacturerEditSubmit(val)]"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionManufacturerList from './sections/SectionManufacturerList'
import DialogFormManufacturerAdd from '../dialogs/DialogFormManufacturerAdd'
import DialogFormManufacturerEdit from '../dialogs/DialogFormManufacturerEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionManufacturerList,
    DialogFormManufacturerAdd,
    DialogFormManufacturerEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormManufacturerAdd: false,
    showDialogFormManufacturerEdit: false,
    manufacturerList: [],
    manufacturerToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormManufacturerAddSubmit(data) {
      this.isLoadingCount++
      this._insertManufacturer({
        name: data.name,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormManufacturerAdd = false
          this.fetchLists()
          this.$emit('notify', {
            message: 'Manufacturer successfully created!',
          })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormManufacturerEditSubmit(data) {
      this.isLoadingCount++
      this._updateManufacturer({
        id: data.id,
        name: data.name,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormManufacturerEdit = false
          this.fetchLists()
          this.$emit('notify', {
            message: 'Manufacturer successfully updated!',
          })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Manufacturer'],
        successCb: (data) => {
          this.isLoadingCount--
          this.manufacturerList = data.manufacturers
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.manufacturerList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
